module.exports = __webpack_public_path__ + "static/img/why-3.f8ca6b61.jpg";